<app-navbar></app-navbar>

@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<app-opening (arrowClick)="scrollToElement(demoStep)" (getStartedClick)="scrollToElement(pricingStep)" />

<div id="lp-step-2" #demoStep [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <h2>Faites vous comprendre, par tous et partout.</h2>
    <div id="lp-player">
        <video controls>
            <source src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4" type="video/mp4">
        </video>
    </div>
    <ul id="lp-player-options">
        <li>
            <lucide-angular name="AudioWaveform" size="16"></lucide-angular>
        </li>
        <li class="fill">french</li>
        <li>english</li>
        <li>italian</li>
    </ul>
    <p>Grâce à SVET, parlez en Français, traduisez le en Anglais, et pourquoi pas en Allemand ? Accédez à plus de 15 langues différentes en gardant le timbre de voix de l'interlocuteur principal.</p>
    <div class="gradient-top"></div>
</div>

<div id="lp-step-3" #featuresStep [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <div class="gradient-linear-background"></div>
    <div id="features-conent">
        <div id="features-infos">
            <h3>Enregistrez en français,<br />partagez  le en italien</h3>
            <p>Mais profitez aussi de toutes les autres fonctionnalités proposées par SVET:</p>
            <app-button type="get-stared">{{ 'common.get_started' | translate }}</app-button>
        </div>
        <ul id="features-wrapper">
            @for (feature of features; track $index) {
            <li class="feature">
                <img class="illustration" [src]="feature.imgUrl"
                    [alt]="'svet feature ' + feature.name + ' illustration'">
                <div class="name">{{feature.name}}</div>
            </li>
            }
        </ul>
    </div>
</div>

<div id="lp-step-4" #pricingStep [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <h2>Tarifs</h2>
    @defer (on viewport) {
    <app-pricing></app-pricing>
    } @placeholder {
    <div></div>
    }
    <div class="gradient-top"></div>
</div>

<app-footer></app-footer>